export enum ErrorCodes {
  E_TENANT_LOGIN_MISMATCH = 'E_TENANT_LOGIN_MISMATCH',
}
